<div mat-dialog-title role="heading" aria-level="1">
	New Theme
</div>
<mat-dialog-content>
	<p [matTooltip]="StaticText.ThemeNameToolTip" class="text-muted">
		What should we call your new Theme?
		<i class="fa fa-fw fa-info-circle"></i>
	</p>
	<div>
		<div class="form-group">
			<input type="text"
				[autofocus]="true"
				class="form-control"
				[(ngModel)]="theme.name"
				placeholder="Theme Name"
				aria-label="Name">
		</div>
	</div>
	<p class="text-muted">
		  <small>(You&apos;ll have the opportunity to provide more information shortly.)</small>
	</p>
</mat-dialog-content>
<mat-dialog-actions>
	<button (click)="cancel()" class="btn btn-link" [disabled]="closing">
		Cancel
	</button>
	<button (click)="save()" class="btn btn-primary" [disabled]="closing">
		Save
	</button>
</mat-dialog-actions>
